import { useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import { BusinessHoursEditor } from "./BusinessHoursEditor";
import "./ListingsHomeTab.scss";

export function ListingsHomeTab() {
  // Placeholder source-of-truth menu — wiring to a real menu picker comes later.
  const [sourceOfTruth] = useState({
    name: "Main Menu 2026",
    lastPublish: "February 19, 2026 · 11:23 AM",
  });

  return (
    <div className="listings-home">
      <div className="listings-home-cards">
        <div className="listings-card source-of-truth-card">
          <button type="button" className="card-edit-btn" aria-label="Edit source of truth">
            <EditOutlined />
          </button>
          <div className="card-label">Source of Truth:</div>
          <div className="card-title">{sourceOfTruth.name}</div>
          <div className="card-meta">
            <span className="card-meta-label">Last publish:</span> {sourceOfTruth.lastPublish}
          </div>
          <div className="card-icon">
            <MenuBookIcon />
          </div>
        </div>

        <div className="listings-card placeholder-card">
          <span>TBD</span>
        </div>

        <div className="listings-card placeholder-card">
          <span>TBD</span>
        </div>
      </div>

      <BusinessHoursEditor />
    </div>
  );
}

function MenuBookIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" viewBox="0 0 22 17" fill="none">
      <path d="M20.4953 8.65844e-07H15.0678C13.9031 8.65844e-07 12.7645 0.334473 11.7848 0.965462L10.6272 1.70794L9.46959 0.965462C8.49087 0.334594 7.35097 -0.000621787 6.18654 8.65844e-07H0.759085C0.339216 8.65844e-07 0 0.339217 0 0.759086V14.2328C0 14.6527 0.339216 14.9919 0.759085 14.9919H6.18654C7.35127 14.9919 8.48989 15.3264 9.46959 15.9574L10.5228 16.6358C10.5537 16.6548 10.5892 16.6667 10.6248 16.6667C10.6604 16.6667 10.696 16.6572 10.7268 16.6358L11.7801 15.9574C12.7621 15.3264 13.9031 14.9919 15.0678 14.9919H20.4953C20.9152 14.9919 21.2544 14.6527 21.2544 14.2328V0.759086C21.2544 0.339217 20.9152 8.65844e-07 20.4953 8.65844e-07ZM6.18654 13.284H1.70794V1.70794H6.18654C7.02628 1.70794 7.8423 1.94753 8.54683 2.40061L9.70443 3.14309L9.86811 3.24983V14.2091C8.73897 13.6019 7.47699 13.284 6.18654 13.284ZM19.5464 13.284H15.0678C13.7774 13.284 12.5154 13.6019 11.3863 14.2091V3.24983L11.55 3.14309L12.7076 2.40061C13.4121 1.94753 14.2281 1.70794 15.0678 1.70794H19.5464V13.284ZM7.89686 4.74428H3.48942C3.39691 4.74428 3.321 4.82494 3.321 4.92219V5.98966C3.321 6.08692 3.39691 6.16757 3.48942 6.16757H7.89449C7.987 6.16757 8.06291 6.08692 8.06291 5.98966V4.92219C8.06528 4.82494 7.98937 4.74428 7.89686 4.74428ZM13.1891 4.92219V5.98966C13.1891 6.08692 13.265 6.16757 13.3575 6.16757H17.7626C17.8551 6.16757 17.931 6.08692 17.931 5.98966V4.92219C17.931 4.82494 17.8551 4.74428 17.7626 4.74428H13.3575C13.265 4.74428 13.1891 4.82494 13.1891 4.92219ZM7.89686 8.06528H3.48942C3.39691 8.06528 3.321 8.14593 3.321 8.24319V9.31066C3.321 9.40791 3.39691 9.48857 3.48942 9.48857H7.89449C7.987 9.48857 8.06291 9.40791 8.06291 9.31066V8.24319C8.06528 8.14593 7.98937 8.06528 7.89686 8.06528ZM17.765 8.06528H13.3575C13.265 8.06528 13.1891 8.14593 13.1891 8.24319V9.31066C13.1891 9.40791 13.265 9.48857 13.3575 9.48857H17.7626C17.8551 9.48857 17.931 9.40791 17.931 9.31066V8.24319C17.9334 8.14593 17.8575 8.06528 17.765 8.06528Z" fill="#333333"/>
    </svg>
  );
}
